const initials = (name) => {
  if (/\S+@\S+\.\S+/.test(name)) return name.charAt(0).toUpperCase(); // a guest email address
  let names = name ? name.match(/\b\w/g) : [];
  return ((names.shift() || "") + (names.pop() || "")).toUpperCase();
};

export default initials;
